import {
  ParentFolder,
  ChildFavoriteListFolder,
  FolderInformation,
  GrandChildFavoriteListFolder
} from '../../../models/my_catalog_register/my_catalog_register_js_env';

export class MyCatalogRegisterView {

  static createMyCatalogInsertSelectedFolderInner(): string {
    return `<button class="m-btn -tertiary -middle is-disabled js-addfolderBtn"
                disabled="" type="button" id="my-catalog-insert-selected-folder">
              <span class="m-btn_inner"><span class="m-btn_text">選択したフォルダに登録</span></span>
            </button>`
  }

  static createFolderHtml(parentFolders: ParentFolder[], parentFolderTitle: string , canDisplayFolders: boolean, registeredFolderCodes: number[]): string {
    if(!canDisplayFolders) {
      return ``;
    }
    const parentFolderHtml: string = this.getParentFolderHtml(parentFolders, canDisplayFolders, registeredFolderCodes);
    return `
      <button class="o-addfolderlist_hdg js-accordion_btn" type="button">
        <span class="a-text u-text-bold">${parentFolderTitle}</span>
      </button>
      <div class="o-addfolderlist_items js-accordionTarget">
        <div class="js-accordionTarget_inner">
          ${parentFolderHtml}
        </div>
      <div>`;
  }

  static getParentFolderHtml(parentFolders: ParentFolder[], canDisplayFolders: boolean, registeredFolderCodes: number[]): string {

    let resultHtml: string = "";

    if(!canDisplayFolders) {
      return resultHtml;
    } else if(canDisplayFolders && parentFolders.length === 0) {
      return `<p class="a-text u-mb-16">フォルダがありません</p>`;
    };

    parentFolders.forEach((parentFolder) => {

      const childFolderHtml: string = this.getChildFolderHtml(parentFolder.childFavoriteListFolders, parentFolder.folderShareType);

      const folderName: string = <string>(parentFolder.folderInformation as FolderInformation)!.folderName;

      const folderItemCount: number = <number>(parentFolder.folderInformation as FolderInformation)!.folderItemCount;

      const folderCode: number = <number>(parentFolder.folderInformation as FolderInformation)!.folderCode;

      const folderManagerId: string = <string>(parentFolder.folderInformation as FolderInformation)!.folderManagerId;

      const folderFlg: boolean = registeredFolderCodes.indexOf(folderCode) >= 0;

      if(folderFlg) {
        resultHtml += `
          <li>
            <div class="o-colBox -aicenter -margin8">
              <label class="a-radiobtn -disabled">
                <span class="a-radiobtn_inner">
                  <input type="radio" name="myCatalogFolder" value="${folderCode}" data-folder-name="${folderName}" data-folder-share-type="${parentFolder.folderShareType}" data-folder-manager-id="${folderManagerId}" disabled/>
                  <span class="a-radiobtn_label">${folderName}（${folderItemCount}）</span>
                </span>
              </label>
              <span class="a-tag -bgLightblue">登録済み</span>
            </div>
            ${childFolderHtml}
          </li>`;
      } else {
        resultHtml += `
          <li>
            <label class="a-radiobtn">
              <span class="a-radiobtn_inner">
                <input type="radio" name="myCatalogFolder" value="${folderCode}" data-folder-name="${folderName}" data-folder-share-type="${parentFolder.folderShareType}" data-folder-manager-id="${folderManagerId}" />
                <span class="a-radiobtn_label">${folderName}（${folderItemCount}）</span>
              </span>
            </label>
            ${childFolderHtml}
          </li>`;
      }
    });

    return resultHtml;
  }

  static getChildFolderHtml(childFavoriteListFolders: ChildFavoriteListFolder[], folderShareType: string): string {

    let resultHtml: string = "";

    resultHtml += `<ul class="o-addfolderlist_list_child">`;

    childFavoriteListFolders.forEach((childFolder) => {

      const grandChildFolderHtml: string = this.getGrandChildFolderHtml(childFolder.grandChildFavoriteListFolders, folderShareType);

      const folderName: string = <string>(childFolder.folderInformation as FolderInformation)!.folderName;

      const folderItemCount: number = <number>(childFolder.folderInformation as FolderInformation)!.folderItemCount;

      const folderCode: number = <number>(childFolder.folderInformation as FolderInformation)!.folderCode;

      const folderManagerId: string = <string>(childFolder.folderInformation as FolderInformation)!.folderManagerId;


      resultHtml += `
        <li>
          <label class="a-radiobtn">
            <span class="a-radiobtn_inner">
              <input type="radio" name="myCatalogFolder" value="${folderCode}" data-folder-name="${folderName}" data-folder-share-type="${folderShareType}" data-folder-manager-id="${folderManagerId}" />
              <span class="a-radiobtn_label">${folderName}（${folderItemCount}）</span>
            </span>
          </label>
          ${grandChildFolderHtml}
        </li>`;
    });

    resultHtml += `</ul>`;

    return resultHtml;
  }

  static getGrandChildFolderHtml(grandChildFavoriteListFolders: GrandChildFavoriteListFolder[], folderShareType: string): string {

    let resultHtml: string = "";

    resultHtml += `<ul class="o-addfolderlist_list_child">`;

    grandChildFavoriteListFolders.forEach((grandChildFolder) => {

      const folderName: string = <string>(grandChildFolder.folderInformation as FolderInformation)!.folderName;

      const folderItemCount: number = <number>(grandChildFolder.folderInformation as FolderInformation)!.folderItemCount;

      const folderCode: number = <number>(grandChildFolder.folderInformation as FolderInformation)!.folderCode

      const folderManagerId: string = <string>(grandChildFolder.folderInformation as FolderInformation)!.folderManagerId;

      resultHtml += `
        <li>
          <label class="a-radiobtn">
            <span class="a-radiobtn_inner">
              <input type="radio" name="myCatalogFolder" value="${folderCode}" data-folder-name="${folderName}" data-folder-share-type="${folderShareType}" data-folder-manager-id="${folderManagerId}" />
              <span class="a-radiobtn_label">${folderName}（${folderItemCount}）</span>
            </span>
          </label>
        </li>`;
    });

    resultHtml += `</ul>`;

    return resultHtml;
  }

  static getSimpleCompleteModalHtml() {

    return `
      <div id="my-catalog-tooltip" class="m-tooltipContent js-lazy-img js-tooltipContent" data-event="click" style="width:0; height:0;">
        <div class="m-tooltipContent_trigger js-tooltipContent_trigger">
          <button type="button" id="my-catalog-tooltip-trigger" hidden></button>
        </div>
        <div class="m-tooltipContent_target js-tooltipContent_target">
          <div class="a-tooltip -action js-tooltip" style="width:217px">
            <span class="a-tooltip_arrow js-tooltip_arrow"></span>
            <div class="a-tooltip_content">
              <div class="o-colBox -aicenter -margin16 u-mb-16">
                <div class="a-img -static">
                  <span class="a-img_imgWrap">
                    <img id="my-catalog-item-image"
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN89h8AAtEB5wrzxXEAAAAASUVORK5CYII="
                      class="a-img_img js-lazy-img" alt="" width="56"/>
                  </span>
                </div>
                <p class="a-text -small -noWrap">マイカタログに<br/>登録しました</p>
              </div>
              <div class="o-colBox -aicenter -margin16 -fdcolumn">
                <button class="m-btn -tertiary -small" type="button" id="my-catalog-to-my-catalog-link">
                  <span class="m-btn_inner">
                    <span class="m-btn_text">マイカタログへ</span>
                  </span>
                </button>
                <a href="javascript:void(0);" class="a-textlink js-tooltipContent_close">閉じる</a>
              </div>
            </div>
          </div>
        </div>
      </div>`;
  }
}
